/* unplugin-vue-components disabled */import script from "./GiftBasicForm.vue?vue&type=script&setup=true&lang=js"
export * from "./GiftBasicForm.vue?vue&type=script&setup=true&lang=js"

import "./GiftBasicForm.vue?vue&type=style&index=0&id=ddf9dd70&lang=scss&scoped=true"

import exportComponent from "/Users/fubeibei/TRAE_workspace/cuiwei_xcxsc/cw/travel-manage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ddf9dd70"]])

export default __exports__